import { ReactElement } from 'react';

import { InteractiveTable, useInteractiveTableContext } from '@dreryk/react-components';
import { createInterpolatedTranslationKey, priceRangeFormatter, useTranslate } from '@dreryk/react-common';

import { getCalculatedTotalEstimatedDuration } from '../../../../shared/receptionService.utils';
import { receptionServiceTranslationKeys } from '../../../../translations';

import { ReceptionServiceTableBean } from './ReceptionServiceInteractiveTable.types';
import {
   getCalculatedTotalAdvancePaymentValue,
   getCalculatedTotalPriceRange,
} from './ReceptionServiceInteractiveTableSummary.utils';

const t = receptionServiceTranslationKeys.extensions.calendar.appointment.table;
type ReceptionServiceInteractiveTableSummaryProps = {
   onlinePaymentsIntegrationExists: boolean;
};
export const ReceptionServiceInteractiveTableSummary = (
   props: ReceptionServiceInteractiveTableSummaryProps
): ReactElement => {
   const translate = useTranslate();
   const { getValues } = useInteractiveTableContext<ReceptionServiceTableBean>();
   const receptionService = getValues();

   return (
      <InteractiveTable.Summary label={t.summary.label}>
         <InteractiveTable.SummaryCell width={'190px'} testId={'price'}>
            {translate(
               createInterpolatedTranslationKey(t.summary.price, {
                  total: priceRangeFormatter(getCalculatedTotalPriceRange(receptionService)),
               })
            )}
         </InteractiveTable.SummaryCell>
         {props.onlinePaymentsIntegrationExists ? (
            <InteractiveTable.SummaryCell width={'105px'} testId={'advancePayment'}>
               {translate(
                  createInterpolatedTranslationKey(t.summary.advancePayment, {
                     total: getCalculatedTotalAdvancePaymentValue(receptionService),
                  })
               )}
            </InteractiveTable.SummaryCell>
         ) : null}
         <InteractiveTable.SummaryCell width={'105px'} testId={'estimatedDuration'}>
            {translate(
               createInterpolatedTranslationKey(t.summary.estimatedDuration, {
                  total: getCalculatedTotalEstimatedDuration(receptionService),
               })
            )}
         </InteractiveTable.SummaryCell>
         <InteractiveTable.SummaryCell width={'24px'} testId={'options'} />
      </InteractiveTable.Summary>
   );
};
